import { media, spacing, color } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import "../../typography/elements.js";
import { min } from "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { white } from "../../layout/background/box.js";
import "../../layout/background/highlight.js";
import "../../layout/background/full.js";
import "../../layout/background/quarter.js";
import "../../layout/background/wrap.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-asset-image";
const base = {
  position: `relative`,
  display: `inline-block`,
  overflow: `hidden`
};
const imageBase = {
  display: `block`
};
const imageScaled = {
  ...imageBase,
  objectFit: "cover",
  objectPosition: "center",
  width: "100%",
  height: "100%"
};
const imageAnimationStart = {
  transform: "scale(1)",
  transition: "transform 0.5s"
};
const imageAnimationEnd = {
  transform: "scale(1.025)"
};
const linkBase = {
  lineHeight: `0`,
  overflow: `hidden`,
  display: `flex`
};
const signBase = {
  [`& .${white.className}`]: {
    position: `absolute`,
    bottom: `${spacing.min}`,
    left: `${spacing.min}`,
    [`@media (max-width: ${media.breakpointValues.large.min}px)`]: {
      display: `none`
    }
  }
};
const linkImage = {
  "& img": {
    ...imageBase
  },
  "& > a": {
    ...linkBase,
    "& img": {
      ...imageAnimationStart
    }
  },
  [`a:hover, a:focus`]: {
    "& > img": {
      ...imageAnimationEnd
    }
  }
};
const linkImageScaled = {
  "& img": {
    ...imageBase,
    ...imageAnimationStart,
    ...imageScaled
  },
  "& > a": {
    ...linkBase,
    height: "100%",
    width: "100%",
    "& img": {
      ...imageAnimationStart
    }
  },
  [`a:hover, a:focus`]: {
    "& > img": {
      ...imageAnimationEnd
    }
  }
};
function composeWrapper(options) {
  const { scaled = false } = options || {};
  let composed = {
    ...base,
    ...signBase
  };
  if (scaled) {
    composed = {
      ...composed,
      width: "100%",
      height: `100%`,
      ...linkImageScaled
    };
  } else {
    composed = {
      ...composed,
      ...linkImage
    };
  }
  const className = scaled ? `${classNamePrefix}-wrapper-scaled` : `${classNamePrefix}-wrapper`;
  return objectWithClassName({
    ...composed,
    className
  });
}
function composeAspect(options) {
  const { ratio = "standard" } = options || {};
  let aspectValue;
  let className;
  if (ratio === "square") {
    aspectValue = "1/1";
    className = `${classNamePrefix}-aspect-square`;
  } else {
    aspectValue = "4/3";
    className = `${classNamePrefix}-aspect-standard`;
  }
  return objectWithClassName({
    aspectRatio: aspectValue,
    width: "auto",
    "& img": {
      aspectRatio: aspectValue,
      width: "auto"
    },
    className
  });
}
const caption = objectWithClassName({
  ...min,
  className: `${classNamePrefix}-caption`,
  position: "absolute",
  bottom: "0",
  right: "0",
  height: "auto !important",
  width: "auto !important",
  padding: `${spacing.min}`,
  backgroundColor: ` rgba(0, 0, 0, 0.5)`,
  color: `${color.white}`,
  zIndex: "99"
});
const wrapper = composeWrapper();
const wrapperScaled = composeWrapper({ scaled: true });
const aspectStandard = composeAspect({ ratio: "standard" });
const aspectSquare = composeAspect({ ratio: "square" });
export {
  aspectSquare,
  aspectStandard,
  caption,
  composeAspect,
  composeWrapper,
  wrapper,
  wrapperScaled
};
//# sourceMappingURL=image.js.map
